// extracted by mini-css-extract-plugin
export default {"container":"SelectCategory_container__Bu5KS","formCheckInput":"SelectCategory_formCheckInput__q3fbY","textContiner":"SelectCategory_textContiner__SDe0m"};